// extracted by mini-css-extract-plugin
export default {"buttonTopMargin":"PersonalData_buttonTopMargin__UUEXL","personalDataPage":"PersonalData_personalDataPage__JG1N0"};